import SecondaryFooter from "@aitisal/ui/common/SecondaryFooter";

export default function CheckoutFooter() {
  return <SecondaryFooter />;
}
